// extracted by mini-css-extract-plugin
export const accountsTable = "DeviceSettingsModule__accountsTable__XufXG";
export const atlasGrotesk = "'AtlasGrotesk'";
export const body = "DeviceSettingsModule__body__CVzZp";
export const bold = "700";
export const cell = "DeviceSettingsModule__cell__5mZxz";
export const creditAccountDetails = "DeviceSettingsModule__creditAccountDetails__7LCHr";
export const debtsAccountDetails = "DeviceSettingsModule__debtsAccountDetails__0tlKR";
export const deviceTable = "DeviceSettingsModule__deviceTable__MbPDq";
export const down = "DeviceSettingsModule__down__-1Gf2";
export const emptyState = "DeviceSettingsModule__emptyState__ElsK5 BalanceAccountSettingsModule__emptyState__shYhk";
export const footer = "DeviceSettingsModule__footer__M+2IV";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const headerCell = "DeviceSettingsModule__headerCell__p5QeM";
export const headerRow = "DeviceSettingsModule__headerRow__BVKjk";
export const headerTitle = "DeviceSettingsModule__headerTitle__FzV5A";
export const medium = "500";
export const pageSizeSelectorWrapper = "DeviceSettingsModule__pageSizeSelectorWrapper__JKlR7";
export const paginatorWrapper = "DeviceSettingsModule__paginatorWrapper__KrOZT";
export const pointing = "DeviceSettingsModule__pointing__Id+Ak";
export const regular = "400";
export const responsiveTitle = "DeviceSettingsModule__responsiveTitle__jpoN-";
export const responsiveTitleText = "DeviceSettingsModule__responsiveTitleText__QiYJ-";
export const row = "DeviceSettingsModule__row__c05dN";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const sortingWrapper = "DeviceSettingsModule__sortingWrapper__y0l2G";
export const table = "DeviceSettingsModule__table__2mxlK";
export const tableInner = "DeviceSettingsModule__tableInner__BMBcI";
export const textCenter = "DeviceSettingsModule__textCenter__w0T9T";
export const tooltipIconWrapper = "DeviceSettingsModule__tooltipIconWrapper__IgCtt";
export const up = "DeviceSettingsModule__up__198op";
export const white = "DeviceSettingsModule__white__w1xTO";
export const withHelpText = "DeviceSettingsModule__withHelpText__KsrYG";